module.exports = __webpack_public_path__ + "static/media/project4.41ed388c.jpg";